
import {  Outlet } from "react-router-dom";

export default function PublicComponent(params) {

    return<div className="page-wrapper"><Outlet/></div> 
}